import React, { useEffect, useState } from 'react';
import { getQuestionnaireStats } from '../../services/question.services';

const QuestionnaireStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getQuestionnaireStats()
      .then(res => {
        if (res?.success) {
          setStats(res.data);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const getBarColor = (percent) => {
    const p = parseFloat(percent);
    if (p >= 80) return "bg-success";
    if (p >= 60) return "bg-info";
    if (p >= 40) return "bg-primary";
    if (p >= 20) return "bg-warning";
    return "bg-danger";
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" style={{ width: "4rem", height: "4rem" }}></div>
        <h5 className="mt-3">Loading Statistics...</h5>
      </div>
    );
  }

  if (!stats || stats.stats.length === 0) {
    return <div className="text-center py-5">No answers yet</div>;
  }

  return (
    <div className="container-fluid my-4">
      <div className="card shadow">
        <div className="card-header bg-dark text-white">
          <h3 className="mb-0">Questionnaire Statistics (Admin)</h3>
        </div>
        <div className="card-body">
          <div className="row mb-4">
            <div className="col-md-6">
              <div className="alert alert-info">
                <strong>Total Questions:</strong> {stats.totalQuestions}
              </div>
            </div>
            <div className="col-md-6">
              <div className="alert alert-success">
                <strong>Users Who Answered:</strong> {stats.totalUsersAnswered}
              </div>
            </div>
          </div>

          {stats.stats.map((q) => (
            <div key={q.question_title} className="card mb-4 border-start border-primary border-4">
              <div className="card-body">
                <h5 className="card-title text-primary">
                  {q.question_title}
                </h5>
                <p className="text-muted mb-3">
                  Type: <strong>{q.question_type}</strong> | Answered by <strong>{q.totalAnswered}</strong> users
                </p>

                <div className="row">
                  {Object.entries(q.options).map(([slug, opt]) => (
                    <div key={slug} className="col-lg-6 mb-3">
                      <div className="border rounded p-3 bg-light">
                        <div className="d-flex justify-content-between mb-2">
                          <strong>{slug.toUpperCase()}</strong>
                          <span className="badge bg-dark fs-6">{opt.percentage}%</span>
                        </div>
                        <small className="text-muted d-block mb-2">
                          {opt.selectedCount} user(s) selected
                        </small>
                        <div className="progress" style={{ height: "30px" }}>
                          <div
                            className={`progress-bar progress-bar-striped ${getBarColor(opt.percentage)}`}
                            style={{ width: `${opt.percentage}%` }}
                          >
                            <strong>{opt.percentage}%</strong>
                          </div>
                        </div>
                        <div className="mt-2 small">
                          <strong>EN:</strong> {opt.en} <br />
                          <strong>DE:</strong> {opt.de} <br />
                          <strong>HU:</strong> {opt.hu} <br />
                          <strong>ES:</strong> {opt.es}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuestionnaireStats;